/**
 * Created By Wang Chong 2018/5/17
 */
import Emitter from '../mixins/emitter';
import AsyncValidator from 'async-validator';

export default {
    mixins: [Emitter],
    props: {
        //form层调用规则
        validateEvent: {
            type: Boolean,
            default: true
        },
        //校验规则
        rules: {
            type: [Object, Array]
        }
    },
    data(){
        return {
            currentTips: ''
        }
    },
    /**
     * 组件挂载时绑定事件
     */
    mounted(){
        this.$on('resetValidate', this.resetValidateHandler)
    },
    methods: {
        /**
         * 判断输入内容
         * @param trigger
         * @param callback
         * @param value
         */
        validate: function (trigger, value, callback = function () {}) {
            let rule = this.getRules(trigger);

            //向上层form派发事件
            if (this.validateEvent) {
                this.dispatch('mcFormItem', `el.form.${trigger}`, value);
            }

            if(!rule || !rule.length){
                return false
            }
            const schema = new AsyncValidator({name: rule});
            schema.validate({name: value}, (errors, field) => {
                //把errors和field数组传递给callback
                callback(errors, field);

                //默认去更新currentTips的值
                if(errors){
                    this.currentTips = errors[0].message
                }else{
                    this.currentTips = ''
                }
            });
        },
        // 清空校验
        resetValidateHandler: function () {
            this.currentTips = '';
        },
        /**
         * 获取判断规则
         * @param trigger
         */
        getRules: function (trigger) {
            //过滤掉trigger为空和trigger传入参数不一致的rule
            return this.rules && this.rules.filter(rule => !rule.trigger || rule.trigger.indexOf(trigger) !== -1)
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/validator.js